module.exports = __webpack_public_path__ + "static/blume-bg-d9d3e0112cc0a78988dfa573271fb1ab.mp4";